export enum DialogComponents {
    DeleteChannelDialog = "DeleteChannelDialog",
    SharedLinkDialog = "SharedLinkDialog",
    ChannelSettingsDialog = "ChannelSettingsDialog",
    UploadChannelCoverDialog = "UploadChannelCoverDialog",
    VotedChoiceDialog = "VotedChoiceDialog",
    ExportToDialog = "ExportToDialog",
    CloneChannelDialog = "CloneChannelDialog",
    InvitationDialog = "InvitationDialog",
    PollCreatorDialog = "PollCreatorDialog",
    VoteConfirmationDialog = "VoteConfirmationDialog",
    DeletePollDialog = "DeletePollDialog",
    DeleteTextFieldDialog = "DeleteTextFieldDialog",
    DataCollectionDialog = "DataCollectionDialog",
    CreateChannelDialog = "CreateChannelDialog",
    SubChannelSelectionDialog = "SubChannelSelectionDialog",
    ComponentReorderModal = "ComponentReorderModal",
    AssistantChartPreviewDialog = "AssistantChartPreviewDialog",
    AssistantConversationExportErrorDialog = "AssistantConversationExportErrorDialog",
    CloseEventConfirmationDialog = "CloseEventConfirmationDialog",
    AiReportContextDialog = "AiReportContextDialog",
    InsufficientReportDataDialog = "InsufficientReportDataDialog",
    PresentModeDialog = "PresentModeDialog",
    CompletionRedirectDialog = "CompletionRedirectDialog",
}
